import { BasicDetails } from '../../store/interfaces';
import { routeMappings } from '../../constants';
import { getExperienceInitCookie } from './experienceInitCookie';
import { SessionStore } from '../../constants/sessionStore';
import { getCookie } from './cookies';
import { CompanySettings } from '../interfaces/companySettings';

/** Method to redirect to current workflow item or login page or DPN page conditionally */
const redirectUrlOnInitialize = (basicDetails: BasicDetails): string => {
  const { currentWorkflowItem, template, userSessionActive } = basicDetails;
  let url = routeMappings['NOT_FOUND'];
  const tcPlusFlow = getCookie('TcPlusFlag') === '1';

  if (currentWorkflowItem) {
    const { id, code, capturesPii } = currentWorkflowItem;
    url = `${routeMappings[code]}/${id}`;

    const responseReused = sessionStorage.getItem('responseReuseInfo');
    if (responseReused && !sessionStorage.getItem('responseReuseAcknowledged')) {
      const { url: rrUrl } = JSON.parse(responseReused);
      if (rrUrl) {
        url = rrUrl;
      }
    }

    const isUserLoggedOut = sessionStorage.getItem(SessionStore.loggedoutuser);
    const experienceInitCookie = getExperienceInitCookie();
    const companySettingsString = sessionStorage.getItem(SessionStore.companySettings);
    let companySettings: CompanySettings | null = null;
    if (tcPlusFlow && companySettingsString) {
      companySettings = JSON.parse(companySettingsString);
    }

    if (userSessionActive || (experienceInitCookie && experienceInitCookie.skipLogin)) {
      const isDPNEnabled = tcPlusFlow
        ? companySettings && companySettings.showDpn
        : experienceInitCookie && experienceInitCookie.showDPN;
      const isPreviewProject = experienceInitCookie ? experienceInitCookie.previewProject : false;
      const dpnAccepted = sessionStorage.getItem(SessionStore.dpnAccepted);

      if (dpnAccepted !== 'true' && isDPNEnabled && !isPreviewProject) url = routeMappings['DPN'];

      if (dpnAccepted !== 'true' && template.settings.mfsEnabled)
        url = `${routeMappings['MFS']}${routeMappings['ACCOUNT']}`;
    } else if (template.settings.requiresLogin || capturesPii || isUserLoggedOut) {
      url = template.settings.mfsEnabled ? `${routeMappings['MFS']}${routeMappings['LOGIN']}` : routeMappings['LOGIN'];
    }
  }
  return url;
};

export default redirectUrlOnInitialize;
